import { useCustomerSapExportErrorCategoriesQuery } from "@/common/api/customer-sap-export/use-customer-sap-export-error-categories.query";
import { FilterData } from "../../_types";

/**
 * Fetches the distinct error categories currently present in the customer SAP
 * export data, so the filter only offers values that actually occur in the table.
 */
export const useSapExportErrorCategoryFilterData = (): FilterData => {
  const { data, isPending: isLoading, error } = useCustomerSapExportErrorCategoriesQuery();

  const options = (data?.data ?? []).map((category) => ({ id: category, name: category }));

  return { options, isLoading, error };
};
